import { Context } from '@nuxt/types';
import { refreshSessionCookieIfNeeded } from '@/utils/authUtils';

export default async function ({ $axios }: Context): Promise<void> {
  return refreshSessionCookieIfNeeded($axios);
}
